import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cookie from 'react-cookies';
import styled from "styled-components";
import Common from "../based/Common";
import Request from "../based/Request";
import ArtistServices from "../based/services/ArtistServices";
import { CONSTANTS, NOTIFY, SOCIAL } from "../based/Constants";
import { Notify } from "../based/Notify";
import Logo from "./components/Image/LogoArtist.svg";
import "@fontsource/lexend";


function VerifyPhoneNumberArtist(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [phone, setPhone] = useState({});
    const [message,setMessage] = useState("")
    const [user, setUser] = useState({})
    const [checkPhone, setCheckPhone] = useState(false);
    const history = useHistory()
    const isDesktop = window.innerWidth > 768

    function getPersonalInfo() {
        Request.Get("/api/Artist/get-artist-info")
            .then((res) => {
                let data = res.data;
                setUser(data)
                if(data.isActive){
                    history.push("/")
                }
                if(data.phoneNumber){
                    setCheckPhone(true)
                }
            })
            .catch((err) => {});
    }

    useEffect(() => {
        getPersonalInfo();
    }, []);


 
   
    const hanleSubmit = async() =>{
        if(!phone){
            setMessage("Vui lòng nhập số điện thoại")
        }
        else if(!Common.isValidPhone(phone)){
            setMessage("Số điện thoại sai định dạng")
        }
        else{
            setMessage("")
            let [err, data] = await ArtistServices.UpdateInfoUserArtist({phoneNumber: phone});
            if (!err) {
                getPersonalInfo()
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Gửi thành công, đợi phản hồi từ Ranus nhé !!!");
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
                
            }
        }


    }
    const handleLogout = () =>{
        Common.RemoveToken();
        cookie.remove('token');
        window.location.href = '/login';
          
    }
   
    return (
        <VerifyPhoneNumberArtistStyle>
            <div className="artist">
                        <nav>
                            <div className="logo">
                                <img src={Logo} alt="logo" />
                            </div>
                        </nav>
                        <div className="body-artist">
                            <header>
                                <div className="user-info">
                                    <div className="avatar-user">
                                        {user.avatar ? <img src={user.avatar} alt="avatar" /> : <img src={Logo} alt="avatar mặc định" />}
                                    </div>
                                    <div className="name-user">
                                        <span>Xin chào,</span>
                                        <span className="name">
                                        {user.nickName ? user.nickName : user.firstName && user.lastName && user.firstName + " " + user.lastName}
                                        </span>
                                    </div>
                                </div>
                                <div className="right-info">
                                    <span onClick={()=>{
                                        handleLogout()
                                    }}>Đăng xuất</span>
                                </div>
                            </header>
                            <main>
                                <div className="box-verify">
                                    <div className="title-verify">Xác thực</div>
                                    <div className="desc-verify">Artist vui lòng để lại số điện thoại để Ranus xác thực tài khoản</div>
                                    {checkPhone ? 
                                        <div>
                                            <div className="desc-verify">
                                                Đã gửi số điện thoại, đợi phản hồi từ ranus nhé !!!
                                            </div>
                                            <div className="desc-verify send-more" onClick={()=>{
                                                setCheckPhone(false)
                                            }}>Gửi lại</div>
                                        </div> : 
                                    
                                        <div className="input-submit">
                                        <input type="text" placeholder="Nhập số điện thoại" onChange={(e)=>{
                                            setPhone(e.target.value);
                                            }} />
                                            <button onClick={hanleSubmit}>Gửi</button>
                                        </div>
                                    }
                                    
                                    {message && <div className="message-error">{message}</div>}
                                </div>
                                {!isDesktop && <span className="logout-span" onClick={()=>{
                                        handleLogout()
                                    }}>Đăng xuất</span>}
                            </main>
                        </div>
                    </div>
            
            
        </VerifyPhoneNumberArtistStyle>
    );
}
const VerifyPhoneNumberArtistStyle = styled.div`
    font-family: "Lexend";
    font-style: normal;

    .artist {
        width: 100%;
        margin: 0 auto;
        position: relative;

        .body-artist {
            margin-left: ${window.innerWidth > 1024 ? "calc(1024px / 5)" : "20%"};
            width: ${window.innerWidth > 1024 ? "calc(100% - 1024px / 5)" : "80%"};
            min-height: 100svh;
            background-color: #313131;

            header {
                height: 142px;
                width: 100%;
                background-color: #313131;
                padding:0 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;


                .right-info{
                    display: flex;
                    align-items: center;

                    span{
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #06F1B9;
                        margin-left: 25px;
                        cursor: pointer;
                    }
                }

                .user-info {
                    display: flex;
                    align-items: center;

                    .avatar-user {
                        width: 42px;
                        height: 42px;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 50%;
                        }
                    }
                    .name-user {
                        margin-left: 21px;

                        span {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 25px;
                            letter-spacing: -0.3px;
                            color: #ffffff;

                            &.name {
                                color: #06f1b9;
                                margin-left: 7px;
                            }
                        }
                    }
                }
            }

            main {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .logout-span{
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.3px;
                    color: #06F1B9;
                    margin-left: 25px;
                    cursor: pointer;
                    display: block;
                    margin-top: 25px;
                }
                
                .message-error{
                    text-align: left;
                    color: red;
                    font-size: 14px;
                }
            
                .logo-verify{
                    display: block;
                    position: absolute;
                    top: 20px;
                    left: 20px;
                }
            
                   
                .box-verify{
                    max-width: 95%;
                    width: 470px;
                    padding: 16px;
                    background-color: #313131;   
                    background: #464646;
                    border-radius: 10px;
                    text-align: center;
            
                    .title-verify{
                        font-weight: 600;
                        font-size: 25px;
                        line-height: 31px;
                        letter-spacing: -0.3px;
                        color: #FFFFFF;
                        
                    }
                    .send-more{
                        text-decoration: underline;
                        margin-top: -20px !important;
                        cursor: pointer;
                    }
            
                    .desc-verify{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #06F1B9;
                        margin: 12px 0 32px;
                    }
            
                    .input-submit{
                        display: flex;
                        align-items: center;
                        input{
                            flex-grow: 1;
                            height: 42px;
                            background: #3A3A3A;
                            border-radius: 10px;
                            padding: 0 17px;
                            border: none;
                            outline: none;
                            color: #fff;
            
                            :placeholder{
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 18px;
                                letter-spacing: -0.3px;
                                color: #FFFFFF;
                                opacity: 0.2;
                            }
                        }
            
                        button{
                            width: 114px;
                            height: 42px;
                            background: linear-gradient(259.14deg, #06F1B9 1.32%, #008263 100%);
                            border-radius: 10px;
                            font-weight: 600;
                            font-size: 16px;
                            line-height: 20px;
                            letter-spacing: -0.3px;
                            color: #FFFFFF;
                            display: grid;
                            place-items: center;
                            border: none;
                            margin-left: 16px;
                            outline: none;
                        }
                    }
                }
            }
        }

        nav {
            position: fixed;
            top: 0;
            bottom: 0;
            width: 20%;
            max-width: calc(1024px / 5);
            background-color: #3a3a3a;

            .logo {
                height: 142px;
                width: 100%;
                display: grid;
                place-items: center;

                img {
                    width: 116px;
                    height: 43px;
                    object-fit: contain;
                }
            }

            
        }
    }

    
    @media (max-width: 768px){
        .artist {
          
    
            .body-artist {
                margin-left: 0;
                width: 100%;
         
    
                header {
                    padding:16px;
                    height: auto;
                    .right-info{
                        display: none;
                    }
    
                    .user-info {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        flex-direction: row-reverse;
                        width: 100%;

                        .avatar-user {
                           
                           
                        }
                        .name-user {
                            margin-left: 0;
                        }
                    }
                }
    
                main {
                    .box-verify{
                        margin-top: 100px;
                    }
                }
            }
    
            nav {
                display: none;
                
            }
        }
    }


    
        
    
    
`;
export default VerifyPhoneNumberArtist;



// WEBPACK FOOTER //
// ./src/artist-ui/VerifyPhoneNumberArtist.js